import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FakturniaNavigationService } from '@fakturnia/components/navigation/navigation.service';
import { FakturniaNavigationItem } from '@fakturnia/components/navigation/navigation.types';
import { FakturniaVerticalNavigationComponent } from '@fakturnia/components/navigation/vertical/vertical.component';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector       : 'fakturnia-vertical-navigation-spacer-item',
    templateUrl    : './spacer.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone     : true,
    imports        : [NgClass],
})
export class FakturniaVerticalNavigationSpacerItemComponent implements OnInit, OnDestroy
{
    @Input() item: FakturniaNavigationItem;
    @Input() name: string;

    private _fakturniaVerticalNavigationComponent: FakturniaVerticalNavigationComponent;
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _fakturniaNavigationService: FakturniaNavigationService,
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        // Get the parent navigation component
        this._fakturniaVerticalNavigationComponent = this._fakturniaNavigationService.getComponent(this.name);

        // Subscribe to onRefreshed on the navigation component
        this._fakturniaVerticalNavigationComponent.onRefreshed.pipe(
            takeUntil(this._unsubscribeAll),
        ).subscribe(() =>
        {
            // Mark for check
            this._changeDetectorRef.markForCheck();
        });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
}
